import { Card, Badge, Row, Col } from "antd";
import { CATEGORY_COLORS } from "./colors";

export function ProjectModalContent({ dashboardData }) {

  const categories = [
    { key: "FAO", label: "FAO", data: dashboardData.proyectos.FAO },
    { key: "ORGANIZACIÓN", label: "ORGANIZACIÓN", data: dashboardData.proyectos.ORGANIZACIÓN },
    { key: "POR ASIGNAR", label: "POR ASIGNAR", data: dashboardData.proyectos["POR ASIGNAR"] },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {categories.map(({ key, label, data }) => {
        const colors = CATEGORY_COLORS[key];

        return (
          <div key={key}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
              <Badge
                count={label}
                style={{
                  backgroundColor: colors.badgeBackground || "#999",
                  color: "#fff",
                  fontWeight: "bold",
                  padding: "0 12px",
                  fontSize: 14,
                }}
              />
              <span style={{ fontSize: 14, color: "#999" }}>{data.length} proyectos</span>
            </div>

            <Row gutter={[0, 12]}>
              {data.map((proyecto, idx) => {
                const [codigo, ubicacion] = proyecto.split(" - ");
                const [titulo, ...resto] = (ubicacion || "").split(", ");
                const descripcion = resto.join(", ");

                return (
                  <Col key={idx} span={24}>
                    <Card
                     hoverable
                      style={{
                            border: `1px solid #f0f0f0`, // borde base si lo deseas
                            borderLeft: `4px solid ${colors.borderColor || "#1890ff"}`,
                            padding: 10,
                        }}
                    >
                      <div style={{ display: "flex", gap: 12 }}>
                        <Badge
                          count={codigo}
                          style={{
                            backgroundColor: "#fff",
                            color: colors.textColor || "#1890ff",
                            border: `1px solid ${colors.borderColor || "#1890ff"}`,
                            fontWeight: "bold",
                            marginTop: 4,
                            fontSize: 13,
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <h6 style={{ margin: 0, fontWeight: 500, color: colors.textColor || "#1890ff" }}>
                            {titulo}
                          </h6>
                          <p style={{ margin: 0, fontSize: 13, color: "#888" }}>📍 {descripcion}</p>
                        </div>
                      </div>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </div>
        );
      })}
    </div>
  );
}
